import { useContext } from 'react';

import ChartsDataContext from '../ChartDataContext';

export const useChartIndex = () => {
  const { chartIndex } = useContext(ChartsDataContext);
  return chartIndex;
};
